import useStyles from '../../styles';
import React from 'react';
import successIcon from '../../assests/icons/icon-24x24-success.svg';

interface IToastProps {
  title?: string;
  className?: string;
}

const SuccessToast = (props: IToastProps) => {
  const { title, className } = props;
  const { classes } = useStyles();
  return (
    <div
      className={`flex justify-start font-light items-center h-12 w-96 rounded ${classes.successToast} ${className}`}
    >
      <div className="w-14">
        <img
          src={successIcon}
          className="m-auto"
          alt="icon_here"
        />
      </div>
      <p className="w-72">{title}</p>
    </div>
  );
};

export default React.memo(SuccessToast);
